// The personal-details fields the athlete dashboard's completion score counts.
// A high schooler is asked for a high school; a college athlete is asked for
// their college and years of eligibility instead, never a high school (they
// have none), so their score can reach 100%.
export const PERSONAL_FIELDS = [
  { key: 'gender', label: 'Gender' },
  { key: 'high_school', label: 'High School' },
  { key: 'graduation_year', label: 'Grad Year' },
  { key: 'city', label: 'City/State', alt: 'state' },
  { key: 'cell_phone', label: 'Phone' },
  { key: 'home_address', label: 'Address' },
  { key: 'guardian1_name', label: 'Guardian' },
  { key: 'gpa_weighted', label: 'GPA', alt: 'gpa_unweighted' },
  { key: 'player_photo', label: 'Photo', alt: 'player_photo_2' },
];

const COLLEGE_FIELDS = [
  { key: 'college_name', label: 'College' },
  { key: 'eligibility_years_remaining', label: 'Eligibility' },
];

export function personalFieldsFor(profile) {
  if (profile?.school_level !== 'college') return PERSONAL_FIELDS;
  return PERSONAL_FIELDS.flatMap((f) => (f.key === 'high_school' ? COLLEGE_FIELDS : [f]));
}
